import { render, staticRenderFns } from "./CarrierChat.vue?vue&type=template&id=fcf5d47a"
import script from "./CarrierChat.vue?vue&type=script&lang=js"
export * from "./CarrierChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports